<template>
    <div>
        <div class="text-item half">
            <span>Телефон парковки</span>
            <p>{{ data.contact_phone }}</p>
        </div>
        <div class="separator"></div>

        <div class="inline">
            <div class="grid">
                <strong>Организация:</strong>
                <div class="form-item">
                    <label for="cuit">CUIT</label>
                    <input type="text" id="cuit" class="text-input" v-model="data.booking.cuit" />
                </div>

                <div class="form-item">
                    <label for="orgname">Имя или название организации</label>
                    <input type="text" id="orgname" class="text-input" v-model="data.booking.org_name" />
                </div>
                <div class="form-item">
                    <label for="postaddress">Почтовый адрес</label>
                    <input type="text" id="postaddress" class="text-input" v-model="data.booking.org_address" />
                </div>
                <div class="form-item">
                    <label for="email">Email в системе Mercado Pago</label>
                    <input type="text" id="email" class="text-input" v-model="data.booking.org_email" />
                </div>
            </div>
            <div class="grid">
                <strong>Контактное лицо:</strong>
                <div class="form-item">
                    <label for="fullname">Имя Фамилия</label>
                    <input type="text" id="fullname" class="text-input" v-model="data.booking.org_contact" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>